import { ConstantModel } from 'api/dto/Constant.dto';
import { Resource } from 'model/Resource';
import { TimezoneModel } from 'api/dto/Timezone.dto';

export const STORE_NAME = 'configs';

export namespace ConfigsState {
  export type Domain = {
    constants?: Resource<ConstantModel>;
    timezones?: Resource<TimezoneModel[]>;
  };

  export const INITIAL_CONSTANT: Domain['constants'] = Resource.createPendingResource();
  export const INITIAL_TIMEZONE: Domain['timezones'] = Resource.createPendingResource();

  export const INITIAL_DOMAIN: Domain = {
    constants: INITIAL_CONSTANT,
    timezones: INITIAL_TIMEZONE,
  };
}

export type ConfigsState = {
  configs?: ConfigsState.Domain;
};
